import type { CategorySimple } from '../softwareCategory.types';

export class CategorySimpleModel {
  private readonly _dto: CategorySimple;

  constructor(dto?: CategorySimple) {
    this._dto = dto || {} as CategorySimple;
  }

  get originDTO(): CategorySimple {
    return this._dto;
  }

  get id() {
    return this._dto.id || '';
  }

  get code() {
    return this._dto.code || '';
  }

  get name() {
    return this._dto.name || '';
  }

  get description() {
    return this._dto.description || '';
  }

  get iconUrl() {
    return this._dto.iconUrl || '';
  }
}
